// CDO Agency - Social Media OS sidebar
// userAccessible: true = visible to viewers (sinon admin only)
export const SIDEBAR = [
  {
    id: "dashboard", label: "Dashboard", items: [
      { id: "dashboard", label: "Vue d'ensemble", path: "/", icon: "LayoutDashboard", userAccessible: true },
      { id: "command", label: "Command Center", path: "/command-center", icon: "Crosshair", badge: "NEW" },
      { id: "routine", label: "Routine du jour", path: "/routine", icon: "Clock", userAccessible: true },
    ]
  },
  {
    id: "crm", label: "CRM Social", color: "#EC4899", items: [
      { id: "contacts", label: "Contacts & Leads", path: "/crm/contacts", icon: "Users" },
      { id: "pipeline-crm", label: "Pipeline", path: "/crm/pipeline", icon: "Columns3" },
      { id: "inbox", label: "Boîte de réception DM", path: "/crm/inbox", icon: "Inbox" },
      { id: "segments", label: "Segments", path: "/crm/segments", icon: "Tags" },
      { id: "partnerships", label: "Partenariats & Collab", path: "/crm/partnerships", icon: "Handshake" },
    ]
  },
  {
    id: "accounts", label: "Comptes & Instagram", color: "#7C3AED", items: [
      { id: "ig-accounts", label: "Comptes connectés", path: "/instagram-accounts", icon: "Instagram", badge: "OAUTH" },
      { id: "analytics-pro", label: "Analytics IG", path: "/analytics-pro", icon: "BarChart3", badge: "PRO", userAccessible: true },
      { id: "models-crm", label: "Roster Modèles", path: "/models", icon: "UserSquare2" },
      { id: "shadowban", label: "Shadowban & Sécurité", path: "/shadowban", icon: "ShieldAlert" },
    ]
  },
  {
    id: "strategy", label: "Stratégie & Contenu", color: "#3B82F6", items: [
      { id: "reels", label: "Reels", path: "/reels", icon: "Film", badge: "AI" },
      { id: "carousels", label: "Carousels", path: "/carousels", icon: "Images" },
      { id: "stories", label: "Stories", path: "/stories", icon: "CircleDashed" },
      { id: "hooks-bank", label: "Hooks Viraux", path: "/hooks-bank", icon: "Zap" },
      { id: "captions", label: "Captions IA", path: "/captions", icon: "Type" },
      { id: "swipe-file", label: "Swipe File", path: "/swipe-file", icon: "Bookmark", badge: "PRO" },
      { id: "video-ideas", label: "Idées Vidéos", path: "/video-ideas", icon: "Sparkles" },
      { id: "content-analyzer", label: "Analyzer IA", path: "/content-analyzer", icon: "Brain", badge: "AI" },
      { id: "idea-vault", label: "Idea Vault", path: "/idea-vault", icon: "Lightbulb" },
      { id: "content-table", label: "Tableau Contenus", path: "/content-table", icon: "Table", userAccessible: true },
    ]
  },
  {
    id: "analytics", label: "Analytics & Performance", color: "#7C3AED", items: [
      { id: "kpi", label: "KPI & Métriques", path: "/analytics", icon: "BarChart3", userAccessible: true },
      { id: "perf-pro", label: "Performance Pro", path: "/performance-pro", icon: "Activity", badge: "PRO" },
      { id: "intelligence", label: "Intelligence Hub", path: "/intelligence-hub", icon: "Brain", badge: "AI" },
    ]
  },
  {
    id: "operations", label: "Opérations", color: "#F59E0B", items: [
      { id: "planning", label: "Planning Publication", path: "/planning", icon: "CalendarDays" },
      { id: "posting-planner", label: "AI Posting Planner", path: "/posting-planner", icon: "CalendarClock", badge: "AI" },
      { id: "automation", label: "Automations", path: "/automation", icon: "Bot" },
      { id: "tasks-board", label: "Tâches", path: "/tasks-board", icon: "ListChecks", userAccessible: true },
      { id: "alerts", label: "Alertes", path: "/alerts", icon: "Bell", userAccessible: true },
    ]
  },
  {
    id: "growth", label: "Croissance", color: "#10B981", items: [
      { id: "warmup", label: "Warm-Up Réseaux", path: "/warmup", icon: "Flame" },
      { id: "scaling", label: "Scaling de Comptes", path: "/scaling", icon: "TrendingUp" },
      { id: "comptes-multi", label: "Multi-Comptes", path: "/comptes", icon: "Users2" },
      { id: "mvl", label: "Million Views Lab", path: "/million-views-lab", icon: "Rocket", badge: "LAB" },
      { id: "spy", label: "Spy Concurrence", path: "/spy", icon: "Search" },
      { id: "competitor-intel", label: "Competitor Intel", path: "/competitor-intel", icon: "Crosshair", badge: "AI" },
    ]
  },
  {
    id: "algorithms", label: "Algorithmes & Stratégie", color: "#8B5CF6", items: [
      { id: "algorithmes", label: "Algorithmes Réseaux", path: "/algorithmes", icon: "Network" },
      { id: "strategies", label: "Stratégies Plateformes", path: "/strategies-plateformes", icon: "GitBranch" },
      { id: "watchtime", label: "Watchtime Optim.", path: "/watchtime", icon: "Timer" },
      { id: "errors", label: "Erreurs Fatales", path: "/errors", icon: "AlertOctagon" },
    ]
  },
  {
    id: "team", label: "Équipe & Agence", color: "#EC4899", items: [
      { id: "team-mode", label: "Team Mode", path: "/team-mode", icon: "UserCog", badge: "AUTH" },
      { id: "va-recruiting", label: "Recrutement VA", path: "/va-recruiting", icon: "ClipboardCheck", badge: "QUIZ" },
    ]
  },
];

export const ALL_TABS = SIDEBAR.flatMap(s => s.items);
